export const getValidator = (
  fn: Function,
  errorText: string,
  compareValue: string | number | null = null,
) => ({
  fn,
  errorText,
  compareValue,
})
